import React, { useEffect, useState } from "react";
import { FileSymlink, Plus, Trash2, ChevronDown } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

let _tipos = null;
const hoy = () => new Date().toLocaleDateString("en-CA", { timeZone: "America/Santiago" });
export const referenciasPayload = (refs) => {
  const r = (refs || []).filter((x) => x.tipo || String(x.folio || "").trim());
  return r.length ? r : undefined;
};
export const validarReferencias = (refs) => {
  for (const r of referenciasPayload(refs) || []) {
    if (!r.tipo) return "Referencia: elige el tipo de documento";
    if (!/^[A-Za-z0-9\-_/.]{1,18}$/.test(String(r.folio || "").trim())) return "Referencia: folio obligatorio, sin espacios, máximo 18 caracteres";
    if (!r.fecha) return "Referencia: indica la fecha del documento";
  }
  return null;
};

// Referencias del DTE (orden de compra, HES, contrato, otro documento…): opcionales, se imprimen y van al XML
export default function ReferenciasFields({ value, onChange, prefix = "ref", compact = false }) {
  const [tipos, setTipos] = useState(_tipos || []);
  const refs = value || [];
  const [abierto, setAbierto] = useState(refs.length > 0);
  useEffect(() => {
    if (!_tipos) api.get("/dte-carta/tipos-referencia").then((r) => { _tipos = r.data; setTipos(r.data); }).catch(() => {});
  }, []);
  const set = (i, k, v) => onChange(refs.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  const agregar = () => { onChange([...refs, { tipo: "801", folio: "", fecha: hoy(), razon: "" }]); setAbierto(true); };
  return (
    <div className="rounded-2xl border border-slate-200" data-testid={`${prefix}-section`}>
      <button type="button" onClick={() => (refs.length ? setAbierto(!abierto) : agregar())} data-testid={`${prefix}-toggle`}
        className="w-full flex items-center gap-2 px-4 py-3 text-left">
        <FileSymlink className="w-4 h-4 text-sky-600" />
        <span className="flex-1 text-sm font-semibold text-slate-800">
          Referencias <span className="font-normal text-slate-500">(opcional · orden de compra, HES, contrato…)</span>
        </span>
        {refs.length > 0 && <span className="text-xs text-emerald-600">{refs.length}</span>}
        <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${abierto ? "rotate-180" : ""}`} />
      </button>
      {abierto && (
        <div className="px-4 pb-4 space-y-2">
          {refs.map((r, i) => (
            <div key={i} className={`grid gap-2 items-end ${compact ? "grid-cols-2" : "sm:grid-cols-[1.4fr_1fr_0.9fr_1.4fr_auto]"}`} data-testid={`${prefix}-row-${i}`}>
              <select value={r.tipo} onChange={(e) => set(i, "tipo", e.target.value)} data-testid={`${prefix}-tipo-${i}`}
                className={`h-10 rounded-xl border border-slate-200 px-2 text-sm bg-white ${compact ? "col-span-2" : ""}`}>
                {tipos.map((t) => <option key={t.codigo} value={t.codigo}>{t.codigo} · {t.nombre}</option>)}
              </select>
              <Input value={r.folio} onChange={(e) => set(i, "folio", e.target.value)} maxLength={18} placeholder="N° / folio" data-testid={`${prefix}-folio-${i}`} className="h-10 rounded-xl" />
              <Input type="date" value={r.fecha} onChange={(e) => set(i, "fecha", e.target.value)} data-testid={`${prefix}-fecha-${i}`} className="h-10 rounded-xl" />
              <Input value={r.razon || ""} onChange={(e) => set(i, "razon", e.target.value)} maxLength={90} placeholder="Razón (opcional)" data-testid={`${prefix}-razon-${i}`} className="h-10 rounded-xl" />
              <Button type="button" variant="ghost" size="sm" onClick={() => onChange(refs.filter((_, j) => j !== i))} data-testid={`${prefix}-quitar-${i}`}>
                <Trash2 className="w-4 h-4 text-rose-500" />
              </Button>
            </div>
          ))}
          <Button type="button" variant="outline" size="sm" onClick={agregar} data-testid={`${prefix}-agregar`}><Plus className="w-4 h-4 mr-1" />Agregar referencia</Button>
        </div>
      )}
    </div>
  );
}
